import { FC, useRef, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useOnClickOutside } from 'usehooks-ts';
import { dateTransform, formatInputDate, parseInputDate } from 'utils';
import Field from 'components/Field';
import Button from 'components/Button';
import { BaseCalendar } from 'components/Calendar';

import styles from './DateField.module.css';
import messages from './DateField.messages';

type Props = {
  form: UseFormReturn<any>;
  name: string;
  placeholder?: string;
  defaultValue?: string;
  inputRef?: any;
  className?: string;
  labelClassname?: string;
  editable?: boolean;
  loading?: boolean;
  disabled?: boolean;
  from?: Date;
};

const DateField: FC<Props> = (props) => {
  const { form, name, from } = props;

  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState<Date>();

  const ref = useRef(null);

  const open = () => {
    const value = form.getValues()[name];
    setSelected(value ? parseInputDate(value) : undefined);
    setIsOpen(true);
  };

  const onSelect = (day?: Date) => {
    setSelected(day);
    if (day) {
      form.setValue(name, formatInputDate(day).replace(/[^\d]/g, '') as never, {
        shouldDirty: true,
      });
    } else {
      form.setValue(name, '');
    }
  };

  const onChangeText = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelected(parseInputDate(e.target.value));
  };

  useOnClickOutside(ref, () => {
    setIsOpen(false);
  });

  return (
    <div ref={ref} className={styles.wrapper}>
      <Field
        type={'text'}
        maxLength={10}
        {...props}
        {...dateTransform}
        onFocus={open}
        onChangeText={onChangeText}
        autoComplete={'off'}
      />

      {isOpen && (
        <div className={styles.calendarWrapper}>
          <BaseCalendar
            mode={'single'}
            selected={selected}
            onSelect={onSelect}
            fromDate={from}
          />

          <div className={styles.buttonsContainer}>
            <Button
              onClick={() => {
                setIsOpen(false);
              }}
            >
              {messages.confirmButton}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DateField;
